module.exports = __webpack_public_path__ + "static/img/三维山体模型.72f83db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/三维山体模型.jpg
// module id = ZToC
// module chunks = 1